import React, { useState } from 'react';
import {
	Flex,
	Text,
	Button,
	Image,
	View,
	useBreakpointValue,
} from '@aws-amplify/ui-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_NAME } from '../../utils/utils';
import LanguageSwitcher from './LanguageSwitcher';
import WaitlistModal from '../common/WaitlistModal';

export default function SiteNavBar() {
	const { t } = useTranslation('app');
	const navigate = useNavigate();
	const location = useLocation();
	const [menuOpen, setMenuOpen] = useState(false);
	const [waitlistOpen, setWaitlistOpen] = useState(false);

	const isMobile = useBreakpointValue({
		base: true,
		medium: false,
	});

	const navLinks = [
		{ label: t('nav.home'), path: '/' },
		{ label: t('nav.projects'), path: '/projects' },
		{ label: t('nav.team'), path: '/founders' },
	];

	const isActive = (path) => location.pathname === path;

	return (
		<>
			<View
				as="nav"
				backgroundColor="white"
				borderBottom="1px solid rgba(0,0,0,0.1)"
				position="sticky"
				top="0"
				style={{ zIndex: 100 }}
			>
				<Flex
					maxWidth="1200px"
					margin="0 auto"
					padding="12px 24px"
					justifyContent="space-between"
					alignItems="center"
				>
					{/* Logo */}
					<Flex
						alignItems="center"
						gap="8px"
						onClick={() => navigate('/')}
						style={{ cursor: 'pointer' }}
					>
						<Image
							src="/images/logo.png"
							alt={APP_NAME}
							width="36px"
							height="36px"
						/>
						<Text fontWeight="700" fontSize="20px" color="#047d6a">
							{APP_NAME}
						</Text>
					</Flex>

					{/* Desktop nav */}
					{!isMobile && (
						<Flex alignItems="center" gap="24px">
							{navLinks.map((link) => (
								<Text
									key={link.path}
									onClick={() => navigate(link.path)}
									fontWeight={isActive(link.path) ? '600' : '400'}
									color={isActive(link.path) ? '#047d6a' : 'rgba(0,0,0,0.7)'}
									fontSize="14px"
									style={{ cursor: 'pointer' }}
								>
									{link.label}
								</Text>
							))}
							<LanguageSwitcher />
							<Button
								variation="primary"
								size="small"
								onClick={() => setWaitlistOpen(true)}
							>
								{t('nav.joinWaitlist')}
							</Button>
						</Flex>
					)}

					{/* Mobile hamburger */}
					{isMobile && (
						<Flex alignItems="center" gap="8px">
							<LanguageSwitcher />
							<Button
								variation="link"
								onClick={() => setMenuOpen(!menuOpen)}
								fontSize="24px"
								padding="4px 8px"
							>
								{menuOpen ? '✕' : '☰'}
							</Button>
						</Flex>
					)}
				</Flex>

				{/* Mobile menu */}
				{isMobile && menuOpen && (
					<Flex
						direction="column"
						padding="0 24px 16px"
						gap="12px"
						backgroundColor="white"
						borderBottom="1px solid rgba(0,0,0,0.1)"
					>
						{navLinks.map((link) => (
							<Text
								key={link.path}
								onClick={() => {
									navigate(link.path);
									setMenuOpen(false);
								}}
								fontWeight={isActive(link.path) ? '600' : '400'}
								color={isActive(link.path) ? '#047d6a' : 'rgba(0,0,0,0.7)'}
								fontSize="16px"
								padding="8px 0"
								style={{ cursor: 'pointer' }}
							>
								{link.label}
							</Text>
						))}
						<Button
							variation="primary"
							size="small"
							onClick={() => {
								setWaitlistOpen(true);
								setMenuOpen(false);
							}}
						>
							{t('nav.joinWaitlist')}
						</Button>
					</Flex>
				)}
			</View>

			<WaitlistModal
				isOpen={waitlistOpen}
				onClose={() => setWaitlistOpen(false)}
			/>
		</>
	);
}
